import Vue from 'vue';

const success = (context, response) => {
  const newBlob = new Blob([response.data], { type: 'application/pdf' });
  const data = window.URL.createObjectURL(newBlob);
  const filename = `${context.rental.name} - Booking ${context.booking.id} - ${context.guest.first_name} ${context.guest.last_name}.pdf`;
  const link = document.createElement('a');
  link.href = data;
  link.download = filename;
  link.click();
};

const failed = () => {
  toastr.error('Booking not found');
};


export default context => Vue.$http.get(`generate-pdf/${context.booking.id}`, { responseType: 'arraybuffer' })
         .then((response) => {
           if (response && response.status === 200) {
             success(context, response);
           }
         }).catch((error) => {
           failed(error);
         });



// WEBPACK FOOTER //
// ./src/app/services/invoice/generatePdf.js